// @ts-expect-error: no types yet in the library package
import tokens from '@nike/design-system-base';
import { Dialog } from '@nike/nike-design-system-components';
import styled from '@emotion/styled';

const CookieDialogStyled = styled(Dialog, {
  shouldForwardProp: prop =>
    prop !== 'isLoading' &&
    prop !== 'isLearnMoreShown' &&
    prop !== 'hasCookieDialogActions' &&
    prop !== 'height',
})<{
  isLoading: boolean;
  isLearnMoreShown: boolean;
  hasCookieDialogActions: boolean;
  height: number;
}>`
  &.dialog-base {
    ${({ height, isLoading }) => height && !isLoading && `height: ${height}px;`};
    ${props => (props.isLoading ? 'min-height: auto;' : '')}
  }

  .dialog-backdrop-container {
    ${({ isLoading }) => isLoading && 'min-height: auto;'}
    ${({ isLearnMoreShown }) => (isLearnMoreShown ? `padding: 0 0 36px 0;` : `padding: 0;`)}

    ${({ hasCookieDialogActions, isLoading }) =>
      `&:after {
            content: '';
            display: block;
            position: absolute;
            bottom: ${hasCookieDialogActions && !isLoading ? '36px' : '0px'};
            left: 0;
            width: 100%;
            height: 36px;
            z-index: 0;
            background: #ffffff;
            background: linear-gradient(
              to top,
              rgba(255, 255, 255, 1) 0%,
              rgba(255, 255, 255, 1) ${hasCookieDialogActions ? '0%' : '33%'},
              rgba(255, 255, 255, 0) 100%
            );
          }`}
  }

  .dialog-main {
    padding: ${({ hasCookieDialogActions }) =>
      hasCookieDialogActions ? '48px 60px 36px 60px' : '48px 60px 48px 60px'};
    @media only screen and (max-width: ${tokens.bp('tablet')}px) {
      padding: ${({ hasCookieDialogActions }) =>
        hasCookieDialogActions ? '36px 24px 24px 24px' : '36px 24px 36px 24px'};
      max-height: initial;
    }
  }

  .dialog-content {
    padding-bottom: 12px;
  }

  .dialog-header-container {
    display: none;
  }
`;

export { CookieDialogStyled };
